/**
 * Mutación para cargar las bases al formulario.
 * 
 * @param {*} state contiene la informacion del formulario. 
 * @param {*} bases contiene la información de las bases.
 */
export function cargarBases(state, bases) {
    
    state.selectedBases.bases = [];

    for(var i=0; i<bases.length;i++){
        state.selectedBases.bases.push(bases[i]);
    }
    state.selectedBases.verPaginadorBase = false;


    if (state.selectedBases.paginadorBase >= state.selectedBases.bases.length) {
        state.selectedBases.verPaginadorBase = false;
    } else {
        state.selectedBases.verPaginadorBase = true;
    }  
}

/**
 * Mutación para cargar las áreas al formulario.
 * 
 * @param {*} state contiene la informacion del formulario.
 * @param {*} areas contiene la información de las áreas.
 */
export function cargarAreas(state, areas) {
    
    state.selectedAreas.areas = [];

    for(var i=0; i<areas.length;i++){
        state.selectedAreas.areas.push(areas[i]);
    }
    state.selectedAreas.verPaginadorArea = false;
    
    if (state.selectedAreas.paginadorArea >= state.selectedAreas.areas.length) {
        state.selectedAreas.verPaginadorArea = false;
    } else {
        state.selectedAreas.verPaginadorArea = true;
    }
    
}

/**
 * Mutación para cargar las áreas y bases al formulario.
 * 
 * @param {*} state contiene la informacion del formulario.
 * @param {*} bases_areas contiene la información de las áreas y bases.
 */
export function cargarBasesAreas(state, bases_areas) {
    
    state.selectedBasesAreas.bases_areas = [];

    
    for(var i=0; i<bases_areas.length;i++){
        state.selectedBasesAreas.bases_areas.push(bases_areas[i]);
    }
    state.selectedBasesAreas.viewPaginador = false;
    state.selectedBasesAreas.paginador = 5;

    if (state.selectedBasesAreas.paginador >= state.selectedBasesAreas.bases_areas.length) {
        state.selectedBasesAreas.viewPaginador = false;
    } else {
        state.selectedBasesAreas.viewPaginador = true;
    }
    
}

